module.exports = __webpack_public_path__ + "static/hero-1db6e9952aa2eeb788786a5efb99e104.png";